const getBasketAddonRowKey = ({ addonIri, day, dietIri, connectedToIri }) =>
  [addonIri, day, dietIri ?? 'noDiet', connectedToIri ?? 'notConnected'].join(
    '|'
  );

export default getBasketAddonRowKey;
